import { useQueries, useQuery } from '@tanstack/react-query'
import makeApiCall from 'utils/api'
import { Discount, Pharmacy, Settings } from 'types/pharmacy'
import { QueryKey } from 'react-query'

export function usePharmacy(id: string) {
  return useQuery<Pharmacy>({
    queryKey: [`pharmacies/${id}`, id],
    queryFn: ({ queryKey }: { queryKey: QueryKey }) => makeApiCall(`${queryKey[0]}`),
    enabled: !!id,
  })
}

export function usePharmacyOrderSettings(params: { pharmacy_id: string; location_id: string }) {
  return useQuery<Settings[]>(
    [
      `/pharmacies/settings?pharmacy_id=${params.pharmacy_id}&location_id=${params.location_id}`,
      params,
    ],
    {
      queryFn: ({ queryKey }: { queryKey: QueryKey }) =>
        makeApiCall(`${queryKey[0]}`, 'get', '', {
          params: {
            nopaginate: true,
          },
        }),
      enabled: !!params.pharmacy_id,
      cacheTime:0,
      staleTime:0,
    }
  )
}

export function useMultiplePharmacyDetail(ids?: string[]) {
  const queries = useQueries({
    queries: ids
      ? ids.map((item) => {
          return {
            queryKey: [`pharmacies/${item}`, item],
            queryFn: async ({ queryKey }: { queryKey: QueryKey }) => {
              const data = await makeApiCall<Pharmacy>(`${queryKey[0]}`)
              return data
            },
            enabled: !!item,
          }
        })
      : [],
  })

  // Aggregate isLoading and isError states
  const isLoading = queries?.some((query) => query.isLoading)
  const isError = queries?.some((query) => query.isError)
  const data = queries?.map((item) => item.data)
  return {
    isLoading,
    isError,
    data,
  }
}

export function useDiscounts() {
  return useQuery<Discount[]>(['/pharmacies/discounts/applicable'], {
    queryFn: ({ queryKey }: { queryKey: QueryKey }) =>
      makeApiCall(`${queryKey[0]}`, '', '', {
        params: {
          nopaginate: true,
        },
      }),
  })
}
